<div>
	<div class="modal-body">
		<div class="row">
			<div class="col-lg-12">
				<p>{{ "modal_not_found_feature_unavailable" | translate }}</p>
				<p>
					IF YOU SEE THIS: PLEASE GO TO SLACK AND SEND ME <br />
					"/gif stop resisting"
				</p>
			</div>
		</div>
	</div>
	<div class="modal-footer">
		<button type="button" class="btn btn-default pull-left" data-dismiss="modal" (click)="close()">
			{{ "close" | translate }}
		</button>
	</div>
</div>
